@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.modal-body {
  padding: @space-32;
  height: 480px;
  font-size: 14px;
}

.body-spacing {
  padding-top: @space-24;
}

.cubiscan-icon {
  height: 31px;
  width: 134px;
}

.add-dimensioners {
  margin: 0;
  list-style: inside;
  padding-top: @space-24;
  > li {
    line-height: 24px;
    padding-left: @space-24;
    display: block;
    &:first-of-type {
      padding-top: @space-16;
    }
  }
}
